import { CoreGroup } from "../../../core/geometry/Group";
import { BaseOperation } from "../_Base";
import { NodeContext } from "../../../engine/poly/NodeContext";
import {
  ObjectType,
  OBJECT_CONSTRUCTOR_BY_OBJECT_TYPE,
  CoreConstant
} from "../../../core/geometry/Constant";
import { CoreGeometryIndexBuilder } from "../../../core/geometry/util/IndexBuilder";
export class BaseSopOperation extends BaseOperation {
  static context() {
    return NodeContext.SOP;
  }
  cook(input_contents, params) {
  }
  createCoreGroupFromObjects(objects) {
    const core_group = new CoreGroup();
    core_group.setObjects(objects);
    return core_group;
  }
  createCoreGroupFromGeometry(geometry, type = ObjectType.MESH) {
    const object = BaseSopOperation.createObject(geometry, type);
    return this.createCoreGroupFromObjects([object]);
  }
  createObject(geometry, type, material) {
    return BaseSopOperation.createObject(geometry, type, material);
  }
  static createObject(geometry, type, material) {
    this.createIndexIfNone(geometry);
    const object_constructor = OBJECT_CONSTRUCTOR_BY_OBJECT_TYPE[type];
    material = material || CoreConstant.MATERIALS[type].clone();
    const object = new object_constructor(geometry, material);
    object.castShadow = true;
    object.receiveShadow = true;
    object.frustumCulled = false;
    object.matrixAutoUpdate = false;
    return object;
  }
  createIndexIfNone(geometry) {
    BaseSopOperation.createIndexIfNone(geometry);
  }
  static createIndexIfNone(geometry) {
    CoreGeometryIndexBuilder.createIndexIfNone(geometry);
  }
}
